<template>
  <div>
    <router-view v-if="isMobile" />
    <el-row class="message-container">
      <div
        v-if="isMobile"
        class="back-menu mobile-position-fixed"
      >
        <mobile-back-menu :title="$t('account-settings.messages.title')" />
      </div>
      <el-col
        :sm="8"
        class="users-list"
      >
        <message-user-list :reload-users-list="reloadList" />
      </el-col>
      <el-col
        v-if="!isMobile"
        :sm="16"
        class="message-box"
      >
        <message-box @reloadUsersList="reloadUsersList" />
      </el-col>
      <el-col v-if="isMobile">
        <footer-menu />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import MessageUserList from '@/components/AccountSettings/MessageUserList';
  import MessageBox from '@/components/AccountSettings/MessageBox';
  import FooterMenu from '@/components/Mobile/FooterMenu';
  import MobileBackMenu from '@/components/Mobile/MobileBackMenu';
  import ResourcePage from '@/components/Core/ResourcePage';

  export default {
    components: {
      MobileBackMenu,
      FooterMenu,
      MessageBox,
      MessageUserList,
    },
    extends: ResourcePage,
    data() {
      return {
        reloadList: null,
        activeName: 'first',
        message: '',
        resource: 'messages',
      };
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        user: state => state.auth.user,
      }),
    },
    methods: {
      reloadUsersList(data) {
        this.reloadList = data;
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AccountSettings/Messages.vue